import React, { createContext } from 'react';
import { ensureRootStoreInit } from '~/stores/root-store.utils';
import { getRootStore } from '~/stores/root-cx-store.factory';
import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';

export const StoreContext = createContext<CXRootStore>(null);

export function RootStoreProvider({ children }) {
    const rootStore = getRootStore();

    ensureRootStoreInit(rootStore);

    return (
        <StoreContext.Provider value={rootStore}>
            {children}
        </StoreContext.Provider>
    );
}
